// Racine du slice
export const selectEventsState = (state) => state.events || {};

// Liste d’events
export const selectEventsList = (state) =>
  selectEventsState(state).list || [];

// Event courant (détails / modal)
export const selectCurrentEvent = (state) =>
  selectEventsState(state).current;

// Loading global
export const selectEventsLoading = (state) =>
  !!selectEventsState(state).loading;

// Erreur éventuelle
export const selectEventsError = (state) =>
  selectEventsState(state).error;

// Dernier filtre utilisé
export const selectEventsLastFilter = (state) =>
  selectEventsState(state).lastFilter;
